// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconCloseTablet } from 'components/atoms/icons/IconCloseTablet';
import { Modal } from 'components/atoms/Modal';
import { useTranslation } from 'react-i18next';
import styles from './BatchRegistrationConfirmModal.module.scss';
import { BatchRegistrationWasteUnit, ItemType } from 'util/Types';
import { getUnitLabel, normalizeNumber } from 'util/commons';

type BatchRegistrationConfirmModalProps = {
  handleRegistration: () => Promise<void>;
  onClose: () => void;
  confirmContent: {
    unit: BatchRegistrationWasteUnit;
    totalCount: number;
    totalWeight: number;
  }[];
  showTenantSelectAlert?: boolean;
};

const BatchRegistrationConfirmModal: React.FC<
  BatchRegistrationConfirmModalProps
> = ({
  handleRegistration,
  onClose,
  confirmContent,
  showTenantSelectAlert,
}) => {
  const { t } = useTranslation();

  return (
    <Modal centered className={styles.BatchRegistrationConfirmModal}>
      <div className={styles.Title}>
        <p>{t('emission_input.confirm_title')}</p>
        <IconCloseTablet onClick={onClose} />
      </div>

      <div className={styles.Body}>
        <table className={styles.ConfirmTable}>
          <thead>
            <tr>
              <th>{t('common.item')}</th>
              <th>{t('dashboard.trend_total_weight')}</th>
              <th>{t('batch_registration.count')}</th>
            </tr>
          </thead>

          <tbody>
            {confirmContent.map(({ unit, totalCount, totalWeight }) => (
              <tr key={unit.id}>
                <td>
                  {unit.name}
                  {unit.type === ItemType.FIX &&
                    ` (${unit.convertKg}kg/${unit.quantity}${getUnitLabel(
                      unit.unit
                    )})`}
                </td>
                <td>
                  {normalizeNumber({
                    value: totalWeight,
                  })}
                </td>
                <td>{totalCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.Bottom}>
        {showTenantSelectAlert && (
          <p className={styles.AlertText}>
            {t('batch_registration.tenant_select_alert')}
          </p>
        )}

        <button onClick={handleRegistration}>
          {t('common.button.register')}
        </button>
      </div>
    </Modal>
  );
};

export default BatchRegistrationConfirmModal;
